"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
var _RiskUser = require("@/api/member/RiskUser");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      queryData: {
        queryType: 3,
        riskMemberParam: {
          timeType: '',
          memberId: '',
          memberType: '',
          platform: ''
        },
        page: {
          page: 1,
          size: 10
        }
      },
      total: null,
      // 总条数
      tableData: [],
      platformList: {
        'JD': '京东',
        'TB': '淘宝',
        'PDD': '拼多多'
      }
    };
  },
  mounted: function mounted() {
    this.memberQueryMemberListApi();
  },
  methods: {
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.memberQueryMemberListApi();
    },
    // 重置
    onReset: function onReset() {
      this.queryData = {
        queryType: 3,
        riskMemberParam: {
          timeType: '',
          memberId: '',
          memberType: '',
          platform: ''
        },
        page: {
          page: 1,
          size: 10
        }
      };
      this.memberQueryMemberListApi();
    },
    handleClick: function handleClick(data) {
      var _this = this;
      console.log(data);
      this.$confirm('是否确认取消此风险用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteRiskMemberApi(data.memberId);
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.memberQueryMemberListApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.memberQueryMemberListApi();
    },
    memberQueryMemberListApi: function () {
      var _memberQueryMemberListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _member.memberQueryMemberListApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.tableData = res.data.data || [];
                this.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberListApi() {
        return _memberQueryMemberListApi2.apply(this, arguments);
      }
      return memberQueryMemberListApi;
    }(),
    deleteRiskMemberApi: function () {
      var _deleteRiskMemberApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(memberId) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                memberId: memberId
              };
              _context2.n = 1;
              return (0, _RiskUser.deleteRiskMemberApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.memberQueryMemberListApi();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteRiskMemberApi(_x) {
        return _deleteRiskMemberApi2.apply(this, arguments);
      }
      return deleteRiskMemberApi;
    }()
  }
};